<img id="banner" [src]="config">
